module.exports = __webpack_public_path__ + "img/icon-3.e637aeb9.png";